import { log } from '../../../../utils/notification';

export const getEdgeData = (event) => {
  const debugArray = JSON.parse(event.data) || [{response: 'no debug object'}]; 

  debugArray.forEach(({ response, params, step, style }) => 
    log(`${step} (Edge)`, { params, response }, style)
  );
};
